export default "__VITE_ASSET__ffb2daef__"